import {
  uploadToPresignedUrl,
  type ApiClient,
  type AppSlug,
  type ClientFileRow,
  type CreateFileBody,
  type CreateFileResponse,
  type FileCategory
} from "@app/portal-sdk";

/**
 * Three-step upload: register the file with the API, PUT the bytes to the
 * presigned URL, then confirm completion. Returns the final file row.
 */
export const uploadClientFile = async (
  api: ApiClient,
  clientId: string,
  file: File,
  category: FileCategory,
  onProgress?: (step: "register" | "upload" | "complete") => void,
  appSlug?: AppSlug
): Promise<ClientFileRow> => {
  onProgress?.("register");
  const body: CreateFileBody = {
    name: file.name,
    contentType: file.type || "application/octet-stream",
    size: file.size,
    category,
    appSlug
  };
  const created = await api.request<CreateFileResponse>(`/clients/${clientId}/files`, {
    method: "POST",
    json: body
  });
  onProgress?.("upload");
  await uploadToPresignedUrl(created.uploadUrl, file, created.uploadHeaders);
  onProgress?.("complete");
  return api.request<ClientFileRow>(`/clients/${clientId}/files/${created.file.id}/complete`, {
    method: "POST"
  });
};
